export default __webpack_public_path__ + "static/media/wheat.92f47e9d.svg";